import client, { deserializer } from 'services/client'
import { toSnake } from 'change-object-case'

const URL = '/v2/holder_notification_groups'

export async function getUserGroups(params) {
  const data = await client().get(URL, { params: toSnake(params) })
  return deserializer.deserialize(data)
}
